import React from 'react';
import PropTypes from 'prop-types';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';

import { Icon } from '../../Elements/Elements';

import classes from './BodyMenuChips.module.scss';

const BodyMenuChips = ({ menuConfig, selectOption }) => {
  const language = useUserState().user.language;

  return (
    <ul className={classes.bodyManuChips}>
      {menuConfig.map(({ name, icon, action }) => (
        <li className={classes.chipsWrap} key={action}>
          <button
            className={classes.chips}
            onClick={() => selectOption(action)}
          >
            <Icon icon={icon} className={classes.icon} />
            <p className={classes.text}>{t('menuConfig', name, language)}</p>
          </button>
        </li>
      ))}
    </ul>
  );
};

BodyMenuChips.propTypes = {
  menuConfig: PropTypes.array.isRequired,
  selectOption: PropTypes.func.isRequired
};

export default BodyMenuChips;
